export default __webpack_public_path__ + "static/media/dataCenterFailure.9447877e.png";